import { render, staticRenderFns } from "./zheButton.vue?vue&type=template&id=091feb12&scoped=true&"
import script from "./zheButton.vue?vue&type=script&lang=js&"
export * from "./zheButton.vue?vue&type=script&lang=js&"
import style0 from "./zheButton.vue?vue&type=style&index=0&id=091feb12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091feb12",
  null
  
)

export default component.exports